/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState } from 'react';
import MapContext from "../MapContext.js";
export default function Feature(props) {
  const {
    id,
    type,
    coordinates,
    properties,
    onUnmount,
    data: pData
  } = props;
  const {
    map
  } = useContext(MapContext);
  const [instance, setInstance] = useState();
  const data = pData || map.data;
  useEffect(() => {
    const feat = {
      id: properties.id || id,
      type: 'Feature',
      geometry: {
        coordinates,
        type
      },
      properties: {
        ...properties,
        zoom: map.getZoom(),
        map
      }
    };
    const polygon = data.addGeoJson(feat)[0];
    setInstance(polygon);
    return () => {
      if (polygon) {
        if (onUnmount) {
          onUnmount(polygon);
        }
        data.remove(polygon);
      }
    };
  }, []);
  useEffect(() => {
    if (instance) {
      Object.entries(properties).forEach(([key, value]) => {
        instance.setProperty(key, value);
      });
    }
  }, [properties]);
  return null;
}